
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'RgpdConsentDialog' })
export default class extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: false }) hasDeliveryAddresses!: boolean

  get dialogVisible(): boolean {
    return this.visible
  }

  set dialogVisible(_: boolean) {
    // Dialog cannot be closed without a choice
  }

  consent(accepted: boolean): void {
    this.$emit('consent', accepted)
  }
}
